import * as Sentry from '@sentry/react';
import { isInProduction } from '../apiEndpoint/apiEndpoint.js';
import { getEnvVar } from '../utilities/getEnvs.js';

var fixedTagsAndInfo = function fixedTagsAndInfo(scope) {
  scope.setExtra('application', getEnvVar('NAME') || 'unknown');
  scope.setExtra('version', getEnvVar('VERSION') || 'unknown');
};
var setGiidFromStorage = function setGiidFromStorage(scope) {
  var getGiidFromUrl = function getGiidFromUrl() {
    var queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('giid');
  };
  var getGiidFromSessionStorage = function getGiidFromSessionStorage() {
    if (!sessionStorage) {
      return null;
    }
    try {
      var giidObject = JSON.parse(sessionStorage.getItem('app.settings.selected'));
      if (giidObject && giidObject.installationId) {
        return giidObject.installationId;
      }
    } catch (error) {
      return null;
    }
    return null;
  };
  var giid = getGiidFromUrl() || getGiidFromSessionStorage() || localStorage.getItem('lastInstallationSelected') || 'na';
  scope.setTag('giid', giid);
  scope.setExtra('giid', giid);
};
var extraInfo = function extraInfo(scope, extras) {
  Object.keys(extras).forEach(function (key) {
    var value = extras[key];
    scope.setExtra([key], value);
  });
};
var extraTags = function extraTags(scope, tagData) {
  Object.keys(tagData).forEach(function (key) {
    var value = tagData[key];
    scope.setTag([key], value);
  });
};
var sendLog = function sendLog() {
  var errorLabel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'generic';
  var extras = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tagData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var fingerprint = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var composeError = new Error(errorLabel);
  Sentry.withScope(function (scope) {
    fixedTagsAndInfo(scope);
    if (!('giid' in tagData) || tagData.giid === null || tagData.giid === '') {
      setGiidFromStorage(scope);
    }
    extraInfo(scope, extras);
    extraTags(scope, tagData);
    if (fingerprint) {
      scope.setFingerprint(["fingerprint-".concat(fingerprint)]);
    }
    Sentry.captureException(composeError);
  });
};
var whiteListRegex = /https:\/\/[^\s]+\.verisure\.com/;
var initiliazeSentry = function initiliazeSentry(_ref) {
  var dsn = _ref.dsn,
    release = _ref.release,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? false : _ref$enabled,
    _ref$environment = _ref.environment,
    environment = _ref$environment === void 0 ? 'production' : _ref$environment;
  if (!dsn || !release) {
    console.error('Missing required args', dsn, release);
    throw new Error('Sentry cannot be initialized');
  }
  Sentry.init({
    dsn: dsn,
    release: release,
    environment: environment,
    normalizeDepth: 10,
    enabled: isInProduction || enabled,
    integrations: [new Sentry.Integrations.GlobalHandlers({
      onunhandledrejection: false
    })],
    allowUrls: [whiteListRegex],
    ignoreErrors: [/* Ignore some standard network errors */
    /Network request failed/, /Failed to fetch/, /NETWORK[_|\s]ERROR/i, /Request failed with status code 40[0-1]/, 'AbortError: The user aborted a request.']
  });
};

export { initiliazeSentry, sendLog, whiteListRegex };
